/**
 * Created by Ning Jiang on 2021-05-26.
 */

import {ArrayHelper} from "@nolimitcity/slot-game/bin/utils/ArrayHelper";
import {DeadwoodRip} from "../DeadwoodRip";
import {IReelStateEventData, ReelState} from "../../core/reel/ReelState";

export class ReelStopPresentationController {

    public readonly moduleName:string; // This name is only for dev logging.
    public readonly reelIds:number[];
    public isSkip:boolean;

    constructor(name:string, reels?:number[]) {
        this.moduleName = name;
        if(reels) {
            this.reelIds = reels.concat();
        } else {
            this.reelIds = ArrayHelper.initArrayWithValues(DeadwoodRip.reels.length, index => index);
        }
    }

    public async start():Promise<void> {
        this.reset();
        await Promise.all(this.reelIds.map(reelId => {
            return Promise.all([
                new Promise<void>(resolve => {
                    if(DeadwoodRip.reels[reelId].reelState === ReelState.INACTIVE) {
                        resolve();
                    } else {
                        DeadwoodRip.reels[reelId].events.once(ReelState.BOUNCE, async (data:IReelStateEventData) => {
                            await this.onReelBounce(data);
                            resolve();
                        });
                    }
                }),
                new Promise<void>(resolve => {
                    DeadwoodRip.reels[reelId].events.once(ReelState.STOPPED, async (data:IReelStateEventData) => {
                        await this.onReelStopped(data);
                        resolve();
                    });
                }),
            ]);
        }));
    }

    protected onReelBounce(data:IReelStateEventData):Promise<any> {
        return Promise.resolve();
    }

    // override this with real animation.
    protected onReelStopped(data:IReelStateEventData):Promise<any> {
        return Promise.resolve();
    }

    public skip():void {
        this.isSkip = true;
        // TODO: handle ongoing timelines in bounce or stopped.
    }

    protected reset():void {
        this.isSkip = false;
    }
}